
namespace RioERP.Orders {
    export class OrderFranchiseeShareCalculationColumns {
        static columnsKey = 'Orders.OrderFranchiseeShareCalculation';
    }
}